const uniqueId = () =>
  `produto-recomendado-${Date.now()}-${Math.random().toString(16).slice(2)}`;

const numberOrNull = (value) => {
  if (value === "" || value === null || value === undefined) return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

export const createInspectionRecommendation = (source = {}) => ({
  id: source.id || uniqueId(),
  diagnosisId: source.diagnosisId || "",
  cultureId: source.cultureId === null || source.cultureId === undefined
    ? ""
    : String(source.cultureId),
  cultureName: source.cultureName || "",
  targetId: source.targetId || "",
  targetCatalogId: source.targetCatalogId || null,
  problemId: source.problemId === null || source.problemId === undefined
    ? ""
    : String(source.problemId),
  targetType: source.targetType || "",
  targetName: source.targetName || "",
  targetScientificName: source.targetScientificName || "",
  pesticideId: numberOrNull(source.pesticideId),
  pesticideName: source.pesticideName || "",
  pesticideRegister: source.pesticideRegister || "",
  stockProductId: source.stockProductId || null,
  stockProductName: source.stockProductName || source.pesticideName || "",
  packageId: numberOrNull(source.packageId),
  packageDescription: source.packageDescription || "",
  batch: source.batch || "",
  stockAtRecommendation: numberOrNull(source.stockAtRecommendation),
  unitPrice: numberOrNull(source.unitPrice) || 0,
  taxReference: source.taxReference || null,
  ncm: source.ncm || null,
  indicationId: numberOrNull(source.indicationId),
  doseMinimum: numberOrNull(source.doseMinimum),
  doseMaximum: numberOrNull(source.doseMaximum),
  doseUnit: source.doseUnit || "",
  minimumSprayVolume: numberOrNull(source.minimumSprayVolume),
  maximumSprayVolume: numberOrNull(source.maximumSprayVolume),
  sprayVolumeUnit: source.sprayVolumeUnit || "",
  safetyInterval: source.safetyInterval === null || source.safetyInterval === undefined
    ? ""
    : String(source.safetyInterval),
  reentryInterval: source.reentryInterval || "",
  applicationInterval: source.applicationInterval || "",
  applicationDate: source.applicationDate || "",
  applicationMethodId: numberOrNull(source.applicationMethodId),
  applicationMethodName: source.applicationMethodName || "",
  applicationMethodDescription: source.applicationMethodDescription || "",
  source: source.source === "compendium" ? "compendium" : "stock",
  createdAt: source.createdAt || new Date().toISOString(),
});

export const normalizeInspectionRecommendations = (items) =>
  (Array.isArray(items) ? items : []).map(createInspectionRecommendation);

export const recommendationToPrescriptionProduct = (recommendation) => ({
  id: "",
  idVenda: "",
  idProduto: recommendation.stockProductId,
  nome: recommendation.stockProductName || recommendation.pesticideName,
  embalagem: recommendation.packageDescription,
  dadosAdicionais: `Origem: inspeção, diagnóstico ${recommendation.diagnosisId}`,
  typeProduct: "agrotoxicos",
  quantidade: null,
  valorUnitario: recommendation.unitPrice || 0,
  desconto: 0,
  valorTotal: 0,
  classe_imposto: recommendation.taxReference || null,
  ncm: recommendation.ncm || null,
  unidadeProdVenda: null,
  inspectionRecommendationId: recommendation.id,
  infortecnicaReceita: {
    registroAgrotox: recommendation.pesticideRegister,
    idAgrotoxico: recommendation.pesticideId,
    lote: recommendation.batch,
    agrotoxico: recommendation.pesticideName,
    idEmbalagem: recommendation.packageId,
    embalagem: recommendation.packageDescription,
    idCultura: recommendation.cultureId,
    nomeCultura: recommendation.cultureName,
    idProblema: recommendation.problemId,
    idIndicacao: recommendation.indicationId,
    nomeProblema: recommendation.targetName,
    nomeProblemaCientifico: recommendation.targetScientificName,
    doseBula: [recommendation.doseMinimum, recommendation.doseMaximum]
      .filter((value) => value !== null)
      .join(" - "),
    doseUtilizada: recommendation.doseMinimum || "",
    unidadeDose: recommendation.doseUnit || "",
    volumeCaldaBula: [
      recommendation.minimumSprayVolume,
      recommendation.maximumSprayVolume,
    ]
      .filter((value) => value !== null)
      .join(" - "),
    volumeCaldaUtilizado: recommendation.minimumSprayVolume || "",
    unidadeVolumeCalda: recommendation.sprayVolumeUnit || "",
    intervaloAplicacao: recommendation.applicationInterval || 0,
    intervaloSeguranca: recommendation.safetyInterval,
    maxAplicacoesBula: 0,
    numAplicacoes: null,
    estagioCultura: "",
    formaAplicacao: recommendation.applicationMethodName,
    epocaAplicacao: recommendation.applicationDate,
    doseSelectionMode: "intervalo",
    volumeCaldaSelectionMode: "intervalo",
    areatratar: null,
    medida: "ha",
    modaplicacao: recommendation.applicationMethodDescription,
    modoaplicacao: recommendation.applicationMethodDescription,
    idTipoAplicacao: recommendation.applicationMethodId,
    nomeTipoAplicacao: recommendation.applicationMethodName,
    horario: "",
  },
});
